import AccountCircleSvg from '@/assets/icons/account_circle.svg?react';
import AirlineSeat300Svg from '@/assets/icons/airline_seat_300.svg?react';
import AirlineSeatSvg from '@/assets/icons/airline_seat_recline_normal.svg?react';
import AirplaneTicketSvg from '@/assets/icons/airplane_ticket.svg?react';
import AirportShuttle300Svg from '@/assets/icons/airport_shuttle_300.svg?react';
import AirportShuttleSvg from '@/assets/icons/airport_shuttle.svg?react';
import ArrowForwardSvg from '@/assets/icons/arrow_forward.svg?react';
import ArrowForwardIosSvg from '@/assets/icons/arrow_forward_ios.svg?react';
import ArrowBackSvg from '@/assets/icons/arrow_back.svg?react';
import AttractionsSvg from '@/assets/icons/attractions.svg?react';
import Attractions300Svg from '@/assets/icons/attractions_300.svg?react';
import AutorenewSvg from '@/assets/icons/autorenew.svg?react';
import BeachAccess300Svg from '@/assets/icons/beach_access_300.svg?react';
import Bed300Svg from '@/assets/icons/bed_300.svg?react';
import CalendarMonthSvg from '@/assets/icons/calendar_month.svg?react';
import CalendarMonth300Svg from '@/assets/icons/calendar_month_300.svg?react';
import CheckSvg from '@/assets/icons/check.svg?react';
import CheckCircleFilledSvg from '@/assets/icons/check_circle_filled.svg?react';
import CloseSvg from '@/assets/icons/close.svg?react';
import CompareArrowsSvg from '@/assets/icons/compare_arrows.svg?react';
import ConfirmationNumberSvg from '@/assets/icons/confirmation_number.svg?react';
import CreditCardSvg from '@/assets/icons/credit_card.svg?react';
import DeleteSvg from '@/assets/icons/delete.svg?react';
import DescriptionSvg from '@/assets/icons/description.svg?react';
import DirectionsBoat300Svg from '@/assets/icons/directions_boat_300.svg?react';
import DirectionsBusSvg from '@/assets/icons/directions_bus.svg?react';
import DirectionsCarSvg from '@/assets/icons/directions_car.svg?react';
import DirectionsCar300Svg from '@/assets/icons/directions_car_300.svg?react';
import EditSvg from '@/assets/icons/edit.svg?react';
import EditNoteSvg from '@/assets/icons/edit_node.svg?react';
import EmergencySvg from '@/assets/icons/emergency.svg?react';
import ErrorFilledSvg from '@/assets/icons/error_filled.svg?react';
import EuroSvg from '@/assets/icons/euro.svg?react';
import ExploreSvg from '@/assets/icons/explore.svg?react';
import FileUploadSvg from '@/assets/icons/file_upload.svg?react';
import FileUploadHoverSvg from '@/assets/icons/file_upload_hover.svg?react';
import FilterListSvg from '@/assets/icons/filter_list.svg?react';
import Flight300Svg from '@/assets/icons/flight_300.svg?react';
import FlightSvg from '@/assets/icons/flight.svg?react';
import FlightTakeoffSvg from '@/assets/icons/flight_takeoff.svg?react';
import FreeCancellationSvg from '@/assets/icons/free_cancellation.svg?react';
import HeightSvg from '@/assets/icons/height.svg?react';
import HelpSvg from '@/assets/icons/help.svg?react';
import HomeSvg from '@/assets/icons/home.svg?react';
import HowToReg300Svg from '@/assets/icons/how_to_reg_300.svg?react';
import InfoSvg from '@/assets/icons/info.svg?react';
import InfoFilledSvg from '@/assets/icons/info_filled.svg?react';
import KeyboardArrowDownSvg from '@/assets/icons/keyboard_arrow_down.svg?react';
import KeyboardArrowLeftSvg from '@/assets/icons/keyboard_arrow_left.svg?react';
import KeyboardArrowUpSvg from '@/assets/icons/keyboard_arrow_up.svg?react';
import LightbulbSvg from '@/assets/icons/lightbulb.svg?react';
import LocationAwaySvg from '@/assets/icons/location_away.svg?react';
import LocationAway300Svg from '@/assets/icons/location_away_300.svg?react';
import LocationFilledSvg from '@/assets/icons/location_on_filled.svg?react';
import Location300Svg from '@/assets/icons/location_on_300.svg?react';
import LockSvg from '@/assets/icons/lock.svg?react';
import LogoutSvg from '@/assets/icons/logout.svg?react';
import LuggageSvg from '@/assets/icons/luggage.svg?react';
import Luggage300Svg from '@/assets/icons/luggage_300.svg?react';
import MailSvg from '@/assets/icons/mail.svg?react';
import MenuSvg from '@/assets/icons/menu.svg?react';
import MobileSvg from '@/assets/icons/mobile.svg?react';
import OpenInFullSvg from '@/assets/icons/open_in_full.svg?react';
import OpenInNewSvg from '@/assets/icons/open_in_new.svg?react';
import PendingActionsSvg from '@/assets/icons/pending_actions.svg?react';
import PersonSvg from '@/assets/icons/person.svg?react';
import PersonFilledSvg from '@/assets/icons/person_filled.svg?react';
import PhotoCameraSvg from '@/assets/icons/photo_camera.svg?react';
import PictureAsPdfSvg from '@/assets/icons/picture_as_pdf.svg?react';
import ReportSvg from '@/assets/icons/report.svg?react';
import RestaurantSvg from '@/assets/icons/restaurant.svg?react';
import ScheduleSvg from '@/assets/icons/schedule.svg?react';
import SettingsSvg from '@/assets/icons/settings.svg?react';
import StarFilledSvg from '@/assets/icons/star_filled.svg?react';
import SyncProblemSvg from '@/assets/icons/sync_problem.svg?react';
import SyncProblem300Svg from '@/assets/icons/sync_problem_300.svg?react';
import TimerSvg from '@/assets/icons/timer.svg?react';
import TipLightbulbSvg from '@/assets/icons/tip_lightbulb.svg?react';
import ToggleOffSvg from '@/assets/icons/toggle_off.svg?react';
import ToggleOnSvg from '@/assets/icons/toggle_on.svg?react';
import TrainSvg from '@/assets/icons/train.svg?react';
import Train300Svg from '@/assets/icons/train_300.svg?react';
import VisibilitySvg from '@/assets/icons/visibility.svg?react';
import WorkSvg from '@/assets/icons/work.svg?react';
import Workspaces300Svg from '@/assets/icons/workspaces_300.svg?react';

export const preloadedIcons = {
    accountCircle: AccountCircleSvg,
    airlineSeat300: AirlineSeat300Svg,
    airlineSeat: AirlineSeatSvg,
    airplaneTicket: AirplaneTicketSvg,
    airportShuttle: AirportShuttleSvg,
    airportShuttle300: AirportShuttle300Svg,
    arrowForward: ArrowForwardSvg,
    arrowForwardIos: ArrowForwardIosSvg,
    arrowBack: ArrowBackSvg,
    attractions: AttractionsSvg,
    attractions300: Attractions300Svg,
    autorenew: AutorenewSvg,
    beachAccess300: BeachAccess300Svg,
    bed300: Bed300Svg,
    calendarMonth: CalendarMonthSvg,
    calendarMonth300: CalendarMonth300Svg,
    check: CheckSvg,
    checkCircleFilled: CheckCircleFilledSvg,
    close: CloseSvg,
    compareArrows: CompareArrowsSvg,
    confirmationNumber: ConfirmationNumberSvg,
    creditCard: CreditCardSvg,
    delete: DeleteSvg,
    description: DescriptionSvg,
    directionsBoat300: DirectionsBoat300Svg,
    directionsBus: DirectionsBusSvg,
    directionsCar: DirectionsCarSvg,
    directionsCar300: DirectionsCar300Svg,
    edit: EditSvg,
    editNote: EditNoteSvg,
    emergency: EmergencySvg,
    errorFilled: ErrorFilledSvg,
    euro: EuroSvg,
    explore: ExploreSvg,
    fileUpload: FileUploadSvg,
    fileUploadHover: FileUploadHoverSvg,
    filterList: FilterListSvg,
    flight: FlightSvg,
    flight300: Flight300Svg,
    flightTakeoff: FlightTakeoffSvg,
    freeCancellation: FreeCancellationSvg,
    height: HeightSvg,
    help: HelpSvg,
    home: HomeSvg,
    howToReg300: HowToReg300Svg,
    info: InfoSvg,
    infoFilled: InfoFilledSvg,
    keyboardArrowDown: KeyboardArrowDownSvg,
    keyboardArrowLeft: KeyboardArrowLeftSvg,
    keyboardArrowUp: KeyboardArrowUpSvg,
    lightbulb: LightbulbSvg,
    locationAway: LocationAwaySvg,
    location300: Location300Svg,
    locationAway300: LocationAway300Svg,
    locationFilled: LocationFilledSvg,
    lock: LockSvg,
    logout: LogoutSvg,
    luggage: LuggageSvg,
    luggage300: Luggage300Svg,
    mail: MailSvg,
    menu: MenuSvg,
    mobile: MobileSvg,
    openInFull: OpenInFullSvg,
    openInNew: OpenInNewSvg,
    pendingActions: PendingActionsSvg,
    person: PersonSvg,
    personFilled: PersonFilledSvg,
    photoCamera: PhotoCameraSvg,
    pictureAsPdf: PictureAsPdfSvg,
    report: ReportSvg,
    restaurant: RestaurantSvg,
    schedule: ScheduleSvg,
    settings: SettingsSvg,
    starFilled: StarFilledSvg,
    syncProblem: SyncProblemSvg,
    syncProblem300: SyncProblem300Svg,
    timer: TimerSvg,
    tipLightbulb: TipLightbulbSvg,
    toggle_off: ToggleOffSvg,
    toggle_on: ToggleOnSvg,
    train: TrainSvg,
    train300: Train300Svg,
    visibility: VisibilitySvg,
    work: WorkSvg,
    workspaces300: Workspaces300Svg,
};

export type PreloadedIconKey = keyof typeof preloadedIcons;
